import { Backdrop, Box, Button, CircularProgress, MenuItem, Stack, TextField, Tooltip, Typography, Autocomplete } from '@mui/material';
import { Edit, Settings } from '@mui/icons-material';
import { useEmailsettings } from '../hooks/useEmailSettings';
import { useThemes } from '../../../components/Theme/theme';
import { EmailConfigModal } from '../components/EmailConfigModal';
import { useEffect, useState } from 'react';
import DraggableAction from '../../../components/Buttons/DraggableAction';
import { nav } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';

export function EmailSettings({ title, top, left, select = 1, onSaveComplete = () => {}, parent = 'page' }) {
  const { theme } = useThemes();
  const {
    data,
    allData,
    loadingCreateEM,
    loadingEMaster,
    loadingTList,
    TemplateList,
    modalopen,
    textAreaRef,
    isEditEnabled,
    saveChanges,
    handleChange,
    handleClose,
    handleReset,
    handleOpenEmailSettingsModal,
    handleOnApply,
    setIsEditEnabled,
  } = useEmailsettings({
    select,
    onSaveComplete,
    parent,
  });
  const [bool, setBool] = useState(allData.length > 0);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        boxSizing: 'content-box',
      }}
    >
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loadingCreateEM || loadingEMaster || loadingTList}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        sx={{
          borderRadius: '10px',
          padding: { xs: '8px', sm: '20px' },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '24px',
              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
            }}
          >
            {title}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'end', gap: '20px' }}>
            <Box>
              <Typography
                variant="body1"
                sx={{
                  minWidth: '250px',
                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                  marginBottom: '8px',
                }}
              >
                Set Email Templates
              </Typography>
              <Autocomplete
                id="emailTemplates"
                key={data?.templateid + TemplateList?.length + allData?.length || ''}
                value={TemplateList.find((item) => item.templateid === Number(data?.templateid)) || null}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: 'templateid',
                      value: newValue?.templateid || 0,
                    },
                  });
                }}
                disabled={loadingTList}
                disableClearable
                options={TemplateList}
                getOptionLabel={(option) => option.templatename || ''}
                isOptionEqualToValue={(option, value) => {
                  return option.templateid === value?.templateid;
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.templatename}
                  </Box>
                )}
                noOptionsText="No templates available"
                sx={{
                  minWidth: {
                    md: '565px',
                    xs: '250px',
                  },
                  '& .MuiInputBase-root': {
                    color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme?.palette?.TmId.id.toString().includes('9') ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
                  },
                  '& .MuiAutocomplete-input': {
                    color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={TemplateList.length === 0 ? 'Loading templates...' : 'Select email template'}
                    sx={{
                      '& .MuiInputBase-input': {
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                      },
                    }}
                  />
                )}
              />
            </Box>

            <Typography
              sx={{
                marginTop: '2px',
                marginLeft: '10px',
                marginBottom: '0px',
                fontSize: '11px',
                color: 'danger.main',
              }}
            >
              {data?.errorFields['Templete']}
            </Typography>
            {data?.templateid > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  maxHeight: '56px',
                }}
              >
                {/* <Button
                  onClick={handleOpenEmailSettingsModal}
                  variant="contained"
                  color="primary"
                  sx={{
                    fontSize: { xs: "10px", sm: "14px" },
                    marginLeft: { xs: 2, sm: 4 },
                  }}
                >
                  <Settings />
                </Button> */}
              </Box>
            )}
          </Box>
          {data?.templateid > 0 && (
            <>
              <Box>
                <Typography
                  variant="body1"
                  sx={{
                    minWidth: '250px',
                    color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                  }}
                >
                  Configure Email Body
                </Typography>
                <Box>
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                      gap: 2,
                    }}
                  >
                    <Box sx={{ width: '100%' }}>
                      <TextField
                        multiline
                        ref={textAreaRef}
                        value={data?.emailbody}
                        disabled={bool === false}
                        onChange={handleChange}
                        name="emailbody"
                        minRows={6}
                        maxRows={10}
                        placeholder="Enter your text here"
                        // required={state.billingAddress === "" ? true : false}
                        sx={{
                          width: '100%',
                          height: '100%',
                          // minHeight: "100px",
                          // maxHeight: "200px",
                          borderRadius: '4px',
                          '.css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root': {
                            fontSize: '14px',
                          },
                          label: {
                            fontSize: '14px',
                          },
                          '.css-wgai2y-MuiFormLabel-asterisk': {
                            color: 'danger.main',
                          },
                          '& .Mui-disabled': {
                            WebkitTextFillColor: 'black ',
                            color: 'black ',
                          },
                        }}
                        InputProps={{
                          classes: {
                            input: 'custom-scrollbar', // Your custom class
                          },
                        }}
                      />
                      <Typography
                        sx={{
                          marginTop: '2px',
                          marginLeft: '10px',
                          marginBottom: '0px',
                          fontSize: '11px',
                          color: 'danger.main',
                        }}
                      >
                        {data?.errorFields['emailbody']}
                      </Typography>
                    </Box>

                    <Box sx={{ width: '100%' }}>
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '10px',
                          fontSize: '8px',
                        }}
                      ></Box>
                    </Box>
                  </Box>
                  {parent === 'page' ? (
                    <DraggableAction
                      actionType={'save'}
                      textToCancel="Back to Dashboard"
                      onExit={() => navigate('/')}
                      onSave={
                        bool === false
                          ? null
                          : () => {
                              saveChanges();
                              setBool(false);
                            }
                      }
                      onEnableEdit={() => {
                        setBool(true);
                      }}
                      onReset={
                        !isEditEnabled
                          ? null
                          : () => {
                              handleReset();
                            }
                      }
                    />
                  ) : (
                    <Stack sx={{ justifyContent: 'end' }} spacing={2} direction="row" marginTop={4}>
                      <>
                        {bool ? (
                          <Tooltip
                            arrow
                            title={
                              !select && select !== 0 ? (
                                <Box display="flex" alignItems="center">
                                  <Typography variant="body2" sx={{ fontSize: '11px' }}>
                                    Press <kbd>ctrl</kbd> + <kbd>s</kbd>
                                  </Typography>
                                </Box>
                              ) : (
                                ''
                              )
                            }
                          >
                            <Button
                              variant="contained"
                              onClick={async () => {
                                await saveChanges();
                                setBool(false);
                              }}
                              color="primary"
                              sx={{ fontSize: '14px' }}
                            >
                              Save
                            </Button>
                          </Tooltip>
                        ) : (
                          <Button variant="contained" onClick={() => setBool(true)} color="primary" sx={{ fontSize: '14px' }}>
                            Enable Edit
                          </Button>
                        )}
                        {bool && (
                          <Button variant="outlined" color="primary" sx={{ fontSize: '14px' }} onClick={handleReset}>
                            Reset
                          </Button>
                        )}
                      </>
                    </Stack>
                  )}
                  {/* <Stack sx={{ justifyContent: 'end' }} spacing={2} direction="row" marginTop={4}>
                    {isEditEnabled ? (
                      <>
                        <Tooltip
                          arrow
                          title={
                            !select && select !== 0 ? (
                              <Box display="flex" alignItems="center">
                                <Typography variant="body2" sx={{ fontSize: '11px' }}>
                                  Press <kbd>ctrl</kbd> + <kbd>s</kbd>
                                </Typography>
                              </Box>
                            ) : (
                              ''
                            )
                          }
                        >
                          <Button variant="contained" onClick={() => saveChanges()} color="primary" sx={{ fontSize: '14px' }}>
                            Save
                          </Button>
                        </Tooltip>
                        <Button variant="outlined" color="primary" sx={{ fontSize: '14px' }} onClick={handleReset}>
                          Reset
                        </Button>
                      </>
                    ) : (
                      <Button
                        variant="contained"
                        color="secondary"
                        sx={{
                          fontSize: '14px',
                          background: 'linear-gradient(180deg, #FD5380 0%, #D91C80 100%)',
                          color: '#fff',
                          textTransform: 'none',
                          borderRadius: '8px',
                          padding: '6px 16px',
                        }}
                        onClick={() => setIsEditEnabled(true)}
                        endIcon={<Edit />}
                      >
                        Enable Edit
                      </Button>
                    )}
                  </Stack> */}
                </Box>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {modalopen && (
        <EmailConfigModal
          open={modalopen}
          value={{
            ...data,
          }}
          onClose={handleClose}
          onApply={handleOnApply}
        />
      )}
    </Box>
  );
}
